/* eslint-env node */

// Use require() instead of import for compatibility with stylus
const mpColors = require(`../stylesheets/mixins/colors.json`);

const activeColorScheme = {
  chrome: mpColors[`$chrome`],
  chromeUserIndicator: mpColors[`$blue3`],

  charts: {
    heterogenous: [
      {
        primary: mpColors[`$chart-jersey`],
        secondary: mpColors[`$white`], // usually the text color
      },
      {
        primary: mpColors[`$chart-turquoise`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-green`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-beet`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-orange`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-yellow`],
        secondary: mpColors[`$gray5`],
      },
    ],

    previousComparison: [
      {
        primary: mpColors[`$chart-jersey`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$gray3`],
        secondary: mpColors[`$gray5`],
      },
    ],

    funnels: [
      // funnels completion/dropoff card in dashboard, NOT the analytics Funnels page
      {
        primary: mpColors[`$chart-jersey`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-beet`],
        secondary: mpColors[`$white`],
      },
    ],

    selectable: [
      {
        primary: mpColors[`$chart-jersey`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-turquoise`],
        secondary: mpColors[`$white`],
      },
    ],

    retention: [
      {
        primary: mpColors[`$positive-scale1`],
        secondary: mpColors[`$gray5`],
      },
      {
        primary: mpColors[`$positive-scale2`],
        secondary: mpColors[`$gray5`],
      },
      {
        primary: mpColors[`$positive-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    campaignMessages: [
      {
        primary: mpColors[`$chart-jersey`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-turquoise`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-green`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-beet`],
        secondary: mpColors[`$white`],
      },
    ],

    campaignEmails: [
      {
        primary: mpColors[`$chart-green`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-orange`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-yellow`],
        secondary: mpColors[`$gray4`],
      },
    ],

    impact: [
      {
        primary: mpColors[`$chart-jersey`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-turquoise`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-green`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-beet`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-orange`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart-yellow`],
        secondary: mpColors[`$gray5`],
      },
    ],
  },

  primaryTextColor: mpColors[`$gray5`],
  secondaryTextColor: mpColors[`$gray4`],
  tertiaryTextColor: mpColors[`$gray3`],
  quaternaryTextColor: mpColors[`$gray3`],

  tabActiveText: mpColors[`$gray5`],
  tabInactiveText: mpColors[`$gray3`],
  tabActiveIndicator: mpColors[`$blue1`],

  placeholderText: mpColors[`$gray3`],

  controlPrimary: mpColors[`$blue1`],
  spinner: mpColors[`$blue1`],
  toast: mpColors[`$blue1`],

  upsell: mpColors[`$green1`],

  legendDivider: mpColors[`$gray2`],
  legendBackground: mpColors[`$gray1`],
  darkDivider: mpColors[`$gray2`],
  lightDivider: mpColors[`$gray1`],
  dataAnnotationText: mpColors[`$gray3`],
  tableHeaderBackground: mpColors[`$gray1`],

  positive: mpColors[`$green1`],
  negative: mpColors[`$red1`],

  starFavorite: mpColors[`$orange1`],
  menuItemBackground: mpColors[`$gray1`],
  tagBackground: mpColors[`$gray5`],

  icons: {
    default: mpColors[`$gray3`],
    disabled: mpColors[`$gray3`],
    hover: mpColors[`$blue1`],
  },

  predictGrades: {
    A: {
      primary: mpColors[`$chart-green`],
      secondary: mpColors[`$white`],
    },
    B: {
      primary: mpColors[`$chart-jersey`],
      secondary: mpColors[`$white`],
    },
    C: {
      primary: mpColors[`$chart-yellow`],
      secondary: mpColors[`$gray5`],
    },
    D: {
      primary: mpColors[`$chart-beet`],
      secondary: mpColors[`$white`],
    },
  },

  heatSteps: {
    correlatePositive: [
      {
        step: 0.05,
        primary: mpColors[`$positive-scale0`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.1,
        primary: mpColors[`$positive-scale1`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.2,
        primary: mpColors[`$positive-scale2`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.3,
        primary: mpColors[`$positive-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.4,
        primary: mpColors[`$positive-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.5,
        primary: mpColors[`$positive-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.6,
        primary: mpColors[`$positive-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.8,
        primary: mpColors[`$positive-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: Number.MAX_SAFE_INTEGER,
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    correlateNegative: [
      {
        step: -0.05,
        primary: mpColors[`$negative-scale0`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.1,
        primary: mpColors[`$negative-scale1`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.2,
        primary: mpColors[`$negative-scale2`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.3,
        primary: mpColors[`$negative-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.4,
        primary: mpColors[`$negative-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.5,
        primary: mpColors[`$negative-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.6,
        primary: mpColors[`$negative-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.8,
        primary: mpColors[`$negative-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: Number.MIN_SAFE_INTEGER,
        primary: mpColors[`$negative-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    retention: [
      {
        step: 0.125,
        primary: mpColors[`$positive-scale1`],
        secondary: mpColors[`$gray4`],
      },
      {
        step: 0.25,
        primary: mpColors[`$positive-scale2`],
        secondary: mpColors[`$gray4`],
      },
      {
        step: 0.375,
        primary: mpColors[`$positive-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.5,
        primary: mpColors[`$positive-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.625,
        primary: mpColors[`$positive-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.75,
        primary: mpColors[`$positive-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.875,
        primary: mpColors[`$positive-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: 1.0,
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
      {
        step: `incomplete`,
        primary: mpColors[`$white`],
        secondary: mpColors[`$gray3`],
      },
      {
        step: `zeroBucket`,
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
    ],
  },

  jql: {
    token: {
      comment: `#578c4e`,
      default: `#5e6064`,
      keyword: `#a75c11`,
      literal: `#39946a`,
      number: `#46a609`,
      op: `#92188c`,
      sep: `#bdbec1`,
      string: `#6764c7`,
      variable: `#5e6064`,
    },
  },
};

// old color scheme had variations that have since been deprecated
// map the keys to the correct color set in the new color scheme for backward compatibility
// left-hand-side references can be removed throughout all projects once new color scheme is fully rolled out
activeColorScheme.charts[`stackedBarChart`] = activeColorScheme.charts[`heterogenous`];
activeColorScheme.charts[`insights`] = activeColorScheme.charts[`heterogenous`];
activeColorScheme.charts[`pieChart`] = activeColorScheme.charts[`heterogenous`];
activeColorScheme.charts[`funnelsChart`] = activeColorScheme.charts[`heterogenous`];
activeColorScheme[`previousComparisonNeutralSegmentIconColor`] =
  activeColorScheme.charts[`previousComparison`][1].primary;
activeColorScheme[`barChartLegendBackground`] = activeColorScheme[`legendBackground`];
activeColorScheme[`barChartLegendDivider`] = activeColorScheme[`legendDivider`];
activeColorScheme[`predictHeadingText`] = activeColorScheme[`primaryTextColor`];
activeColorScheme[`predictGradeDescription`] = activeColorScheme[`quaternaryTextColor`];
activeColorScheme[`chartTooltipPositive`] = activeColorScheme[`positive`];
activeColorScheme[`chartTooltipNegative`] = activeColorScheme[`negative`];
activeColorScheme[`correlateRangeBar`] = activeColorScheme[`legendDivider`];
activeColorScheme[`correlateTableHeaderDivider`] = activeColorScheme[`darkDivider`];
activeColorScheme[`correlateTableRowDivider`] = activeColorScheme[`darkDivider`];
activeColorScheme[`controlLabelText`] = activeColorScheme[`controlPrimary`];
activeColorScheme[`exploreLink`] = activeColorScheme[`controlPrimary`];
activeColorScheme[`retentionSelector`] = activeColorScheme[`controlPrimary`];

function rgbFromHexString(hexString) {
  const parts = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return (
    parts && {
      r: parseInt(parts[1], 16),
      g: parseInt(parts[2], 16),
      b: parseInt(parts[3], 16),
    }
  );
}

function rgbaStringFromHexString(hexString, a) {
  const parts = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return `rgba(${parseInt(parts[1], 16)}, ${parseInt(parts[2], 16)}, ${parseInt(parts[3], 16)}, ${a})`;
}

function hexStringFromRgb(rgb) {
  return `#${(0x1000000 + (rgb.r << 16) + (rgb.g << 8) + rgb.b).toString(16).slice(1)}`;
}

function interpolateColor(startColor, endColor, percent) {
  // percent is a decimal in range [0,1]
  const startColorRGB = rgbFromHexString(startColor);
  const endColorRGB = rgbFromHexString(endColor);
  const interpolatedColorRGB = {
    r: startColorRGB.r + Math.floor(percent * (endColorRGB.r - startColorRGB.r)),
    g: startColorRGB.g + Math.floor(percent * (endColorRGB.g - startColorRGB.g)),
    b: startColorRGB.b + Math.floor(percent * (endColorRGB.b - startColorRGB.b)),
  };
  return hexStringFromRgb(interpolatedColorRGB);
}

module.exports = {
  mpColors,
  ...activeColorScheme,
  getChartSegmentColorCombo(idx, chartType = `heterogenous`) {
    const palette = activeColorScheme.charts[chartType];
    return palette && palette[idx % palette.length];
  },
  getPredictGradeColorCombo(gradeLetter) {
    return activeColorScheme.predictGrades[gradeLetter];
  },
  getCorrelatePhiColorCombo(phi) {
    const steps =
      phi >= 0 ? activeColorScheme.heatSteps[`correlatePositive`] : activeColorScheme.heatSteps[`correlateNegative`]; // eslint-disable-line no-multi-spaces
    return steps.find((s) => (phi >= 0 ? phi < s.step : phi > s.step)); // eslint-disable-line no-multi-spaces
  },
  getRetentionColorCombo(heatPercent, zeroBucket = false, incomplete = false) {
    // @heatPercent is a decimal in the range [0,1]
    const steps = activeColorScheme.heatSteps[`retention`];
    return (
      (incomplete && steps.find((s) => s.step === `incomplete`)) ||
      (zeroBucket && steps.find((s) => s.step === `zeroBucket`)) ||
      steps.find((s) => heatPercent <= s.step)
    );
  },
  getRetentionLineColorCombo(idx, lineCount) {
    const palette = activeColorScheme.charts[`retention`];
    const paletteInterval = 1 / (palette.length - 1);
    // Pick the darkest color if only 1 line.
    const linePercent = lineCount === 1 ? 1 : idx / (lineCount - 1);
    const roundedPalettePercent = Math.floor(linePercent / paletteInterval) * paletteInterval;
    const roundedPaletteIndex = Math.round(roundedPalettePercent * (palette.length - 1));
    return {
      primary: interpolateColor(
        palette[roundedPaletteIndex].primary,
        palette[Math.min(roundedPaletteIndex + 1, palette.length - 1)].primary,
        linePercent - roundedPalettePercent,
      ),
      secondary: palette[roundedPaletteIndex].secondary,
    };
  },
  hexStringFromRgb,
  interpolateColor,
  rgbFromHexString,
  rgbaStringFromHexString,
};
